var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubscribeLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 133,
  fill: "none",
  viewBox: "0 0 200 133"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear)",
  fillRule: "evenodd",
  d: "M41.71 112.618v1.323a2.09 2.09 0 0 1-1.767 2.077l-.323 1.202a1.486 1.486 0 0 1-1.433 1.108h-3.21a1.486 1.486 0 0 1-1.432-1.108l-.315-1.202a2.1 2.1 0 0 1-1.775-2.086v-1.323c0-.708.564-1.276 1.267-1.276h7.72a1.28 1.28 0 0 1 1.267 1.285m5.945-17.83a11.14 11.14 0 0 1-3.107 7.742 10.25 10.25 0 0 0-2.718 5.552 1.834 1.834 0 0 1-1.813 1.555h-6.87a1.82 1.82 0 0 1-1.803-1.546c-.324-2.077-1.276-4.052-2.737-5.571a11.14 11.14 0 0 1-3.088-7.61c-.065-6.204 4.836-11.225 10.994-11.272 6.149-.046 11.142 4.965 11.142 11.15m-9.82-6.753c0-.69-.555-1.257-1.248-1.257-4.402 0-7.99 3.605-7.99 8.048 0 .69.555 1.258 1.249 1.258.684 0 1.248-.56 1.248-1.258 0-3.055 2.47-5.533 5.493-5.533.693 0 1.248-.56 1.248-1.258m-1.248-8.057c.684 0 1.248-.56 1.248-1.258v-4.406a1.248 1.248 0 1 0-2.497 0v4.406c0 .699.565 1.258 1.249 1.258M21.894 94.78c0-.69-.555-1.258-1.249-1.258h-4.373c-.684 0-1.249.559-1.249 1.257 0 .69.555 1.258 1.249 1.258h4.373c.694 0 1.249-.559 1.249-1.258m35.008-1.258h-4.374c-.684 0-1.248.559-1.248 1.257 0 .69.555 1.258 1.248 1.258h4.374c.684 0 1.248-.559 1.248-1.258 0-.689-.555-1.257-1.248-1.257M24.437 105.25l-3.098 3.12a1.26 1.26 0 0 0 0 1.78 1.243 1.243 0 0 0 1.757 0l3.098-3.121a1.26 1.26 0 0 0 0-1.779 1.227 1.227 0 0 0-1.757 0m23.422-20.568c.314 0 .637-.121.878-.364l3.098-3.12a1.26 1.26 0 0 0 0-1.78 1.24 1.24 0 0 0-1.767 0l-3.097 3.121a1.26 1.26 0 0 0 0 1.78c.25.242.564.363.888.363m-23.422-.373a1.24 1.24 0 0 0 1.756 0 1.26 1.26 0 0 0 0-1.78l-3.097-3.12a1.24 1.24 0 0 0-1.766 0 1.26 1.26 0 0 0 0 1.78zm24.3 20.941a1.24 1.24 0 0 0-1.766 0 1.26 1.26 0 0 0 0 1.779l3.098 3.121a1.24 1.24 0 0 0 1.756 0c.49-.494.49-1.286 0-1.78z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear)",
  fillRule: "evenodd",
  d: "M60.25 133h-48.2C5.368 133 0 127.646 0 120.98V72.9c0-6.665 5.368-12.02 12.05-12.02h48.2c6.683 0 12.05 5.355 12.05 12.02v48.08c0 6.666-5.367 12.02-12.05 12.02m-48.2-65.563c-3.067 0-5.477 2.404-5.477 5.463v48.08c0 3.06 2.41 5.464 5.477 5.464h48.2c3.068 0 5.478-2.404 5.478-5.464V72.9c0-3.06-2.41-5.463-5.478-5.463z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear)",
  fillRule: "evenodd",
  d: "M187.95 133h-48.2c-6.683 0-12.05-5.354-12.05-12.02V72.9c0-6.665 5.367-12.02 12.05-12.02h48.2c6.682 0 12.05 5.355 12.05 12.02v48.08c0 6.666-5.368 12.02-12.05 12.02m-48.2-65.563c-3.068 0-5.478 2.404-5.478 5.463v48.08c0 3.06 2.41 5.464 5.478 5.464h48.2c3.067 0 5.477-2.404 5.477-5.464V72.9c0-3.06-2.41-5.463-5.477-5.463z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear)",
  fillRule: "evenodd",
  d: "M110.653 39.63a.87.87 0 0 1-.345-1.06c.911-2.272-1.583-6.8-4.799-4.944l-8.355 4.824c-1.635.944-3.684-.215-3.71-2.1-.032-2.316-.44-4.671-1.013-7.245-.618-2.78-3.115-3.67-4.838-2.675-.918.53-1.616 1.594-1.696 3.192-.227 4.598.474 9.326-.462 12.6-.74 2.586-4.52 9.174-4.402 9.378l7.84 13.58a.91.91 0 0 0 1.118.378l5.349-2.09a.9.9 0 0 1 .38-.06c6.103.343 10.866-.614 14.122-2.493a11.8 11.8 0 0 0 2.301-1.714c3.263-3.15 2.156-5.626 1.301-6.75a.9.9 0 0 1 .089-1.187c1.725-1.717.223-4.536-1.196-5.503-.397-.27-.478-.81-.225-1.22 1.05-1.692-.213-4.14-1.459-4.91",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear)",
  fillRule: "evenodd",
  d: "M88.232 89.916c-4.158 0-8.098-2.078-10.396-5.906L53.322 42.564c-1.642-2.734-2.08-6.015-1.313-9.077.766-3.062 2.736-5.686 5.581-7.327L99.067 1.665c5.69-3.39 13.132-1.422 16.524 4.265l24.514 41.446c1.642 2.734 2.079 6.014 1.313 9.076s-2.735 5.687-5.581 7.327L94.251 88.166c-1.86 1.203-3.94 1.75-6.019 1.75m16.963-83.44c-.985 0-1.86.22-2.736.766L60.983 31.738c-1.204.765-2.19 1.968-2.517 3.39-.329 1.421-.11 2.843.547 4.155L83.527 80.73c1.532 2.624 4.924 3.499 7.441 1.968l41.477-24.496c1.203-.765 2.188-1.968 2.517-3.39s.109-2.843-.548-4.156L109.901 9.21c-.985-1.75-2.846-2.734-4.706-2.734",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear)",
  fillRule: "evenodd",
  d: "M177.182 83.15c-.256-.479-.759-.734-1.274-.726a1.41 1.41 0 0 0-1.357.883l-2.091 5.44c-.275.72.093 1.522.822 1.793a1.414 1.414 0 0 0 1.821-.808l1.008-2.624 2.954 5.506a10.3 10.3 0 0 0-3.148-.494c-4.3 0-7.982 2.636-9.484 6.35-2.708-1.072-4.828-.483-5.893-.004-1.504-3.712-5.184-6.346-9.483-6.346-1.12 0-2.195.184-3.203.513l2.965-5.525 1.008 2.624a1.415 1.415 0 0 0 1.821.808 1.386 1.386 0 0 0 .822-1.793l-2.091-5.44c-.218-.566-.774-.897-1.355-.884a1.4 1.4 0 0 0-1.276.726l-7.37 13.738c-.006.01-.005.022-.01.032a9.87 9.87 0 0 0-1.523 5.257c0 5.545 4.581 10.055 10.211 10.055 5.632 0 10.212-4.51 10.212-10.055 0-.315-.019-.626-.048-.935.075-.035.153-.061.223-.111.018-.01 1.714-1.13 4.314.08q-.048.477-.05.966c0 5.545 4.581 10.055 10.211 10.055 5.631 0 10.212-4.51 10.212-10.055a9.9 9.9 0 0 0-1.775-5.656zm-26.126 26.299c-4.074 0-7.387-3.263-7.387-7.274 0-4.01 3.313-7.273 7.387-7.273s7.387 3.262 7.387 7.273-3.314 7.274-7.387 7.274m24.86 0c-4.073 0-7.386-3.263-7.386-7.274 0-4.01 3.313-7.273 7.386-7.273a7.41 7.41 0 0 1 6.052 3.122l.086.162c.03.058.074.102.112.153a7.1 7.1 0 0 1 1.137 3.835c.001 4.012-3.314 7.275-7.387 7.275",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 11.91,
  x2: 11.91,
  y1: 77.958,
  y2: 129.806,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0078"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: -5.22,
  x2: -5.22,
  y1: 68.689,
  y2: 151.284,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0078"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 124.748,
  x2: 124.748,
  y1: 67.96,
  y2: 145.998,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A3D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 62.798,
  x2: 128.268,
  y1: 58.004,
  y2: 87.711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 45.531,
  x2: 88.051,
  y1: 41.434,
  y2: 114.796,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 138.996,
  x2: 138.996,
  y1: 85.349,
  y2: 117.603,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A3D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078FF"
})))));
export default SvgSubscribeLogo;